import * as React from "react";
import { forwardRef } from "react";
const SvgThumbnailIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15.75 2.25H2.25C1.425 2.25 0.75 2.925 0.75 3.75V14.25C0.75 15.075 1.425 15.75 2.25 15.75H15.75C16.575 15.75 17.25 15.075 17.25 14.25V3.75C17.25 2.925 16.575 2.25 15.75 2.25ZM15.75 14.25H2.25V3.75H15.75V14.25ZM3 4.5H9.75V9.75H3V4.5Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgThumbnailIcon);
export { ForwardRef as ReactComponent };
